import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "activity" }
const _hoisted_2 = { class: "formdiv" }

import { ref, reactive } from "vue";
import { ElNotification, FormInstance, FormRules } from 'element-plus'
import { createMessage } from '@/api/api.ts'

interface RuleForm {
  name: string
  phone: string
  module: string[]
  revenue: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'douyin',
  setup(__props) {

const ruleFormRef = ref<FormInstance>()

const formLabelAlign = reactive<RuleForm>({
    name: '',
    phone: '',
    module: [],
    revenue:''
  });

const rules = reactive<FormRules<RuleForm>>({
    name: [
      { required: true, message: '姓名不能为空', trigger: 'blur' },
      { min: 1, max: 30, message: '长度不能超过30个字符', trigger: 'blur' },
    ],
    phone: [
      { required: true, message: "请正确填写11位联系电话", trigger: "blur",pattern:/^1[3-9]\d{9}$/},
    ],
    module: [
      { type: 'array', required: true, message: '请至少选择一个您想要了解的模块', trigger: 'change' },
    ],
    revenue: [
      { required: true, message: '请选择您的企业年营收', trigger: 'change' },
    ]
  });

  const submitForm = async (formEl: FormInstance | undefined) => {
    if (!formEl) return
    await formEl.validate((valid, fields) => {
      if (valid) {
        let formObj = {
          message: ''
        }
        formObj.message = JSON.stringify(formLabelAlign)
        createMessage(formObj).then( (res:any) => {
          console.log(res)
          ElNotification({
            title: 'Success',
            message: '恭喜你，这是一条成功消息',
            type: 'success',
          })
        })
      } else {
        console.log('请正确填写表单！');
      }
    })
  }


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("img", { src: "/img/ycx/adouy.jpg" }, null, -1)),
    _cache[7] || (_cache[7] = _createElementVNode("img", { src: "/img/ycx/adouy2.png" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        "label-position": "top",
        rules: rules,
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        "label-width": "80px",
        model: formLabelAlign
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "您的姓名",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formLabelAlign.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formLabelAlign.name) = $event)),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "您的电话",
            prop: "phone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formLabelAlign.phone,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formLabelAlign.phone) = $event)),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "您的企业年营收",
            prop: "revenue"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: formLabelAlign.revenue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formLabelAlign.revenue) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: "1000w以内" }),
                  _createVNode(_component_el_radio, { label: "1000-3000w" }),
                  _createVNode(_component_el_radio, { label: "3000-8000w" }),
                  _createVNode(_component_el_radio, { label: "8000w以上" })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "您想要了解的模块",
            prop: "module"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: formLabelAlign.module,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formLabelAlign.module) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    label: "财务模块",
                    name: "module"
                  }),
                  _createVNode(_component_el_checkbox, {
                    label: "进销存模块",
                    name: "module"
                  }),
                  _createVNode(_component_el_checkbox, {
                    label: "生产管理",
                    name: "module"
                  }),
                  _createVNode(_component_el_checkbox, {
                    label: "仓储管理",
                    name: "module"
                  }),
                  _createVNode(_component_el_checkbox, {
                    label: "其他模块",
                    name: "module"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm(ruleFormRef.value)))
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("免费申请试用名额")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("img", { src: "/img/ycx/adouy3.png" }, null, -1)),
    _cache[9] || (_cache[9] = _createElementVNode("img", { src: "/img/ycx/adouy4.png" }, null, -1))
  ]))
}
}

})